import {Black, Blue3, Green4, Grey17, Grey6} from "../../theme/styles";

import {EnlilTable} from "../EnlilTable";
import withNavigate from "../../util/useNavigate";
import withBreakpoint from "../../util/withBreakpoint";
import {formatLocal} from "../../util/Formatters";
import {IconButton, Menu, MenuItem, Typography} from "@mui/material";
import {Edit, MoreVert} from "@mui/icons-material";
import css_self from "../Navigation/css/NavBar.module.scss";
import React from "react";
import EventBus from "../../util/EventBus";
import DeveloperApplicationFormApplet from "../../eoec/applet/impl/RestManagement/DeveloperApplicationFormApplet";
import {withAppContext} from "../../util/withAppContext";

class DeveloperApplicationTable extends EnlilTable {

    componentDidMount() {
        super.componentDidMount();

        EventBus.components.addListener("developer-application-form-applet-cancel", this.onCancelHandler);
        EventBus.components.addListener("developer-application-form-applet-save", this.onCancelHandler);
    };

    componentWillUnmount() {
        super.componentWillUnmount();

        EventBus.components.removeListener("developer-application-form-applet-cancel", this.onCancelHandler);
        EventBus.components.removeListener("developer-application-form-applet-save", this.onCancelHandler);
    };

    enterpriseComponentUpdateCompleted(ec) {
        super.enterpriseComponentInsertCompleted(ec)

        ec.invalidateChildren();
    }

    getCellRenderer(name) {
        if (name === "Application Name Cell") {
            return this.renderApplicationNameCell;
        } else if (name === "Employee Cell") {
            return this.renderEmployeeCell;
        } else if (name === "Status Cell") {
            return this.renderStatusCell;
        } else if (name === "Action Cell") {
            return this.renderActionCell;
        }

        return super.getCellRenderer(name);
    };

    handleMenuClick(identifier) {
        if (identifier === "New Application") {
            this.setState({renderTarget: "New Application"});
        }
        super.handleMenuClick(identifier);
    }

    renderExtension() {
        if (this.state.renderTarget === "Edit Application") {
            return <DeveloperApplicationFormApplet enterpriseComponent={this.applet.getEnterpriseComponent()} availableModes={["Edit", "New", "View"]} defaultAction="Edit" />;
        } else if (this.state.renderTarget === "New Application") {
            return <DeveloperApplicationFormApplet enterpriseComponent={this.applet.getEnterpriseComponent()} availableModes={["Edit", "New", "View"]} defaultAction="New" />;
        }
    };

    onCancelHandler = () => {
        this.setState({renderTarget: null});
    };

    renderApplicationNameCell = (___, params, __, _) => {
        if (params.row.id > this.state.buffer.length - 1) return;

        return (
            <div style={{marginTop: "-10px"}}>
                <div style={{fontSize: 14, color: this.state.buffer[params.row.id].get("Active") === true ? Blue3 : Grey6, height: "20px"}}>{this.state.buffer[params.row.id].get("Name")}</div>
                <div style={{fontSize: 11, color: this.state.buffer[params.row.id].get("Active") === true ? Black : Grey6, height: "20px"}}>App ID: {this.state.buffer[params.row.id].get("USID")}</div>
            </div>
        );
    };

    renderEmployeeCell = (___, params, __, _) => {
        if (params.row.id > this.state.buffer.length - 1) return;

        return (
            <div style={{marginTop: "0px"}}>
                <div style={{fontSize: 14, color: this.state.buffer[params.row.id].get("Active") === true ? Black : Grey6, height: "20px"}}>{this.state.buffer[params.row.id].get("EmployeeName")}</div>
            </div>
        );
    };

    renderStatusCell = (___, params, __, _) => {
        if (params.row.id > this.state.buffer.length - 1) return;

        let status;
        let datetime;

        if (this.state.buffer[params.row.id].get("Active") === true) {
            status = "Active"
            datetime = formatLocal(this.state.buffer[params.row.id].get("CreatedDatetime"))
        } else {
            status = "Inactive"
            datetime = formatLocal(this.state.buffer[params.row.id].get("DeactivationDatetime"))
        }
        return (
            <div style={{marginTop: "-11px"}}>
                <div style={{fontSize: 14, color: status === "Active" ? Green4 : Grey6, height: "20px"}}>{status}</div>
                <div style={{fontSize: 11, color: status === "Active" ? Black : Grey6, height: "20px"}}>{datetime}</div>
            </div>
        );
    };

    renderActionCell = (___, params, __, _) => {
        if (params.row.id > this.state.buffer.length - 1) return;

        return (
            <div style={{width: "50px", marginTop: "-4px", backgroundColor: "#FFFFFF", marginLeft: "-10px", marginRight: "-20px", paddingBottom: "5px", paddingLeft: "4px"}}>
                <IconButton onClick={(event) => {
                    if (this.state.tableActionMenuTarget === null) {
                        this.setState({tableActionMenuTarget: event.currentTarget});
                    } else {
                        this.setState({tableActionMenuTarget: null});
                    }
                }}>
                    <MoreVert />
                </IconButton>
                <Menu anchorEl={this.state.tableActionMenuTarget}
                      anchorOrigin={{vertical: "bottom", horizontal: "right"}}
                      transformOrigin={{vertical: -10, horizontal: "center"}}
                      open={this.state.tableActionMenuTarget !== null && this.state.tableActionMenuTarget !== undefined}
                      onClose={() => this.setState({tableActionMenuTarget: null})}
                      TransitionProps={{
                          onExited: () => this.setState({tableActionMenuTarget: null}),
                      }}
                      MenuListProps={{
                          ...{"data-cc-component": "NavMenu"},
                          disablePadding: true,
                          style: {"minWidth": "200px"},
                      }}
                      PaperProps={{
                          elevation: 2,
                      }}
                >
                    <MenuItem divider key={"1"} className={css_self.Standard} onClick={() => {
                        this.setState({tableActionMenuTarget: null, renderTarget: "Edit Application"});
                    }}>
                        <Edit style={{color: Grey6}} />
                        <Typography style={{fontSize: "15px", fontWeight: "400", color: Grey17}}>Edit Application</Typography>
                    </MenuItem>
                </Menu>
            </div>
        )
    }
}

export default withNavigate(withAppContext(withBreakpoint(DeveloperApplicationTable)));